import { render, staticRenderFns } from "./ContentFeedManager.vue?vue&type=template&id=6ff17846&scoped=true"
import script from "./ContentFeedManager.vue?vue&type=script&lang=js"
export * from "./ContentFeedManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff17846",
  null
  
)

export default component.exports